"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Collapse_1 = __importDefault(require("@mui/material/Collapse"));
var react_router_dom_1 = require("react-router-dom");
var NavLink_1 = __importDefault(require("atomicComponents/atoms/NavLink/NavLink"));
var SidebarSubMenuItem = function (_a) {
    var to = _a.to, children = _a.children, href = _a.href, icon = _a.icon, activeIcon = _a.activeIcon, _b = _a.target, target = _b === void 0 ? '_blank' : _b, _c = _a.isExact, isExact = _c === void 0 ? true : _c, subMenuItems = _a.subMenuItems, props = __rest(_a, ["to", "children", "href", "icon", "activeIcon", "target", "isExact", "subMenuItems"]);
    var location = (0, react_router_dom_1.useLocation)();
    var isSubMenu = to && location.pathname.startsWith(to);
    var isActiveLink = (0, react_router_dom_1.useRouteMatch)({ path: to !== null && to !== void 0 ? to : '/page-you-are-not-on', exact: isExact });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(NavLink_1.default, __assign({ to: to, tag: to ? react_router_dom_1.NavLink : undefined, target: href && target, tabIndex: 0, underlined: false }, props, { children: [icon && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: (isActiveLink && activeIcon) || icon, fixedWidth: true }), children] })), (0, jsx_runtime_1.jsx)(Collapse_1.default, __assign({ in: isSubMenu, timeout: "auto", sx: { pl: 3.5 } }, { children: subMenuItems === null || subMenuItems === void 0 ? void 0 : subMenuItems.map(function (_a) {
                    var label = _a.label, link = _a.link, isSubItemExact = _a.isExact;
                    return ((0, jsx_runtime_1.jsx)(NavLink_1.default, __assign({ to: link, tag: react_router_dom_1.NavLink, target: href && target, tabIndex: 0, exact: isSubItemExact }, { children: label }), label));
                }) }))] }));
};
exports.default = SidebarSubMenuItem;
